import { handleRest } from '../../h2Api'
import * as reviewActions from '../../actions/review/reviewActions'

const initialState = {
  data: handleRest(null)
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case reviewActions.LOAD_FILE_REVIEW:
      return {
        ...state,
        data: handleRest(action)
      }
    case reviewActions.UPDATE_APPROVE_FILE_REVIEW:
      return {
        ...state,
        data: {
          ...state.data,
          result: {
            ...state.data.result,
            ...action.data
          }
        }
      }
    default:
      return state
  }
}

export default reducers
